//components
import TextField from "@mui/material/TextField";
import { statusResponseError } from "./module/constants";
import { styled } from "@mui/material/styles";
interface ITextInputFieldUI {
  input: any;
  label: JSX.Element | JSX.Element[];
  meta: any;
  changeForm: any;
  valueForm: string;
  type?: string;
  fullColored: boolean;
}

const TextInputFieldUI = (props: ITextInputFieldUI) => {
  const {
    input,
    label,
    meta,
    changeForm,
    valueForm,
    type,
    fullColored = false,
  } = props;
  const { touched, error } = meta;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    changeForm(input.name, event.target.value);
  };

  const labelInput =
    error && touched
      ? statusResponseError(error.response ? error.response.status : 9999)
      : label;

  return (
    <CssTextField
      type={type}
      error={error && touched}
      id={`${input.name}-text-id`}
      variant="filled"
      label={labelInput}
      value={valueForm || ""}
      fullWidth
      onChange={handleChange}
      sx={{
        color: "#2d32aa",
        backgroundColor: fullColored ? "white" : "#ffffff",
        border: "none",
      }}
    />
  );
};

export const CssTextField = styled(TextField)({
  "& .MuiFilledInput-root": {
    height: "2rem ",
    fontSize: "12px",
    "& fieldset": {
      height: "2rem",
      top: "-8px",
    },
    "&:hover fieldset": {},
    "&.Mui-focused fieldset": {},
  },
  "& .MuiFilledInput-input": {
    height: "2rem",
    fontSize: "12px",
    paddingTop: "10px",
  },
  "& label.Mui-focused": {},
  "& .MuiInput-underline:after": {},
  "& .MuiInputLabel-root": {
    height: "2rem",
    fontSize: "12px",
    top: "-8px",
  },
});

export default TextInputFieldUI;
